<!DOCTYPE HTML>
<template>
<div class="budget_estimate shadow"
     v-if="budget">

  <h1>Budget estimate</h1>
  <h2>${{budget}} ≈ {{estimatedHours}} hrs</h2>

</div>
</template>

<script>
export default {
  name: 'BudgetEstimate',
  props: {
    budget: Number
  },
  computed: {
    estimatedHours() {
      let averageHourlyRate = 175
      return Math.floor( this.budget / averageHourlyRate )
    }
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/global.scss";

.budget_estimate {
    display: grid;
    padding: 3
    rem;
    border-radius: 0.5rem;
    text-align: center;
    align-items: center;
    background: white;

    h1 {
        font-size: 0.7rem !important;
        text-transform: uppercase;
        letter-spacing: 0.1rem;
    }

    h2 {
        font-size: 1.5rem !important;
        color: theme-color-level('success',1);

    }
    h6 {
        font-size: 0.9rem !important;
        b {
            color: theme-color-level('success',2);
        }
    }
}
</style>
